import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { first, map, tap } from 'rxjs/operators';

import { LocationsRouterStoreSelectors } from '@era/stores';
import { Observable } from 'rxjs';
import { DeviceSyncStatusActions } from '../../device-sync/device-sync-statuses-store';

@Injectable()
export class DeviceSyncStatusResolver {
  constructor(private readonly store: Store) {}

  resolve(): Observable<boolean> {
    return this.store.select(LocationsRouterStoreSelectors.selectLocation).pipe(
      tap((location) => {
        this.store.dispatch(
          DeviceSyncStatusActions.DeviceSyncStatusResolverActions.syncStatusesRequested({
            brandId: null,
            locationId: location?.uniqueId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
